/**
 * アクセスページ（大雪エリア外・大雪エリア内）の初期化
 */
export function initAccess($) {
  // 大雪エリア外からのアクセス
  if ($('.s-access-outside').length > 0) {
    initAccessOutside($);
  }

  // 大雪エリア内
  if ($('.s-access-inside').length > 0) {
    initAccessInside($);
  }
}

/**
 * 大雪エリア外からのアクセス
 */
function initAccessOutside($) {
  // 選択した経路を表示する
  function checkChoice() {
    const choiceFrom = $('.s-access__choice-from .s-access__choice-button.active').data('from');
    const choiceTo = $('.s-access__choice-to .s-access__choice-button.active').data('to');

    $('.s-access__route').hide();
    $('.s-access__route--notfound').hide();
    $('.s-access__route--' + choiceFrom + '-' + choiceTo).show();

    // データがない時
    if ($('.s-access__route--' + choiceFrom + '-' + choiceTo).length === 0) {
      $('.s-access__route--notfound').show();
    }
  }

  checkChoice();

  // ボタンクリック
  $('.s-access__choice-from .s-access__choice-button').on('click', function() {
    $('.s-access__choice-from .s-access__choice-button').removeClass('active');
    $(this).addClass('active');
    checkChoice();
  });

  $('.s-access__choice-to .s-access__choice-button').on('click', function() {
    $('.s-access__choice-to .s-access__choice-button').removeClass('active');
    $(this).addClass('active');
    checkChoice();
  });
}

/**
 * 大雪エリア内
 */
function initAccessInside($) {
  // 選択した経路を表示する
  function checkChoice() {
    const choiceFrom = $('.s-access__choice-from .s-access__choice-button.active').data('from');
    const choiceTo = $('.s-access__choice-to .s-access__choice-button.active').data('to');

    $('.s-access__route').hide();
    $('.s-access__route--notfound').hide();
    $('.s-access__route--' + choiceFrom + '-' + choiceTo).show();

    // データがない時
    if ($('.s-access__route--' + choiceFrom + '-' + choiceTo).length === 0) {
      $('.s-access__route--notfound').show();
    }
  }

  checkChoice();

  // ボタンクリック
  $('.s-access__choice-from .s-access__choice-button').on('click', function() {
    $('.s-access__choice-from .s-access__choice-button').removeClass('active');
    $(this).addClass('active');
    checkChoice();
  });

  $('.s-access__choice-to .s-access__choice-button').on('click', function() {
    $('.s-access__choice-to .s-access__choice-button').removeClass('active');
    $(this).addClass('active');
    checkChoice();
  });
}
